import React from 'react';
import { GiftIcon, CheckIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { CtaButton } from '../CtaButton';
import { bonuses } from '../../data/content';
export function Bonuses() {
  return <section className="w-full bg-navy px-4 py-14 sm:px-6 sm:py-20" aria-labelledby="bonuses-title" data-id="element-150" data-mp="1clz9obpw4bzq">
      <div className="mx-auto max-w-5xl" data-id="element-151" data-mp="18l5p9sbnpfbl">
        <div id="bonuses-title" data-id="element-152" data-mp="259v4tbzt9vue">
          <SectionHeading tone="dark" eyebrow="5 exclusive bonuses — free" title="When you get 5-MIN MENOPAUSE™ today, you’ll also receive:" data-id="element-153" data-mp="258sh1cxsc9ip" />
        </div>

        <p className="mx-auto mt-5 flex w-fit items-center gap-2 rounded-full bg-rose px-4 py-2 text-[13px] font-extrabold uppercase tracking-wide text-white" data-id="element-154" data-mp="1w843skg7ud6v">
          <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-155" data-mp="ku0alghgct2v" />
          Total bonus value: $197
        </p>

        <div className="mt-10 space-y-6" data-id="element-156" data-mp="fv6t7cz1ohxf">
          {bonuses.map(bonus => <article key={bonus.tag} className="overflow-hidden rounded-3xl border border-white/10 bg-white/[0.06]" data-id="element-157" data-mp="fx9u4s1qjvgx">
              <img src={bonus.image} alt={`${bonus.title} — included as ${bonus.tag} with 5-MIN MENOPAUSE™`} className="block w-full bg-white" loading="lazy" data-id="element-158" data-mp="1jrgiz5mt6dp6" />

              <div className="p-5 sm:p-7" data-id="element-159" data-mp="1atwelntng1ac">
                <div className="flex flex-wrap items-center gap-2" data-id="element-160" data-mp="w24ak7zb29nx">
                  <span className="rounded-lg bg-rose px-2.5 py-1 text-[11px] font-extrabold uppercase tracking-[0.12em] text-white" data-id="element-161" data-mp="10tlzfxo20jsj">
                    {bonus.tag}
                  </span>
                  <span className="rounded-lg bg-white/10 px-2.5 py-1 text-[11px] font-extrabold uppercase tracking-[0.12em] text-white/80" data-id="element-162" data-mp="r42fspsiolwm">
                    Value: {bonus.value}
                  </span>
                </div>

                <h3 className="mt-3 font-display text-[22px] font-bold leading-tight text-white sm:text-[28px]" data-id="element-163" data-mp="i3nrrio64spf">
                  {bonus.title}
                </h3>
                <p className="mt-3 text-[14.5px] leading-relaxed text-white/75 sm:text-[15.5px]" data-id="element-164" data-mp="2f1v5h69veqku">
                  {bonus.description}
                </p>

                {bonus.items ? <>
                    <p className="mt-5 text-[11px] font-extrabold uppercase tracking-[0.12em] text-rose-light" data-id="element-165" data-mp="261f545ofbzk7">
                      {bonus.listLabel}
                    </p>
                    <ul className="mt-3 flex flex-wrap gap-2" data-id="element-166" data-mp="32p3bjqf4i3nx">
                      {bonus.items.map(item => <li key={item} className="flex items-center gap-1.5 rounded-lg bg-white/10 px-3 py-2 text-[13px] font-semibold text-white" data-id="element-167" data-mp="2tqhjn4nrhcah">
                          <CheckIcon className="h-3 w-3 shrink-0 text-teal" strokeWidth={3} aria-hidden="true" data-id="element-168" data-mp="1ibuh38deyc42" />
                          {item}
                        </li>)}
                    </ul>
                  </> : null}

                {bonus.closing ? <p className="mt-5 border-l-2 border-rose pl-4 text-[13.5px] italic leading-relaxed text-white/70" data-id="element-169" data-mp="188p9ar0ewox6">
                    {bonus.closing}
                  </p> : null}
              </div>
            </article>)}
        </div>

        <div className="mx-auto mt-10 max-w-xl" data-id="element-170" data-mp="1lzau4l9ff8xp">
          <CtaButton label="Yes, give me the 5 bonuses" subtext="$197 in bonuses included free with your $27 purchase" data-id="element-171" data-mp="1lyixr880976d" />
        </div>
      </div>
    </section>;
}